<template>
<div class="grid h100" style="grid-template-columns: auto 1fr;">
<!-- <div class="blocco h100 w100" v-if="loading"><circle4></circle4></div> -->
<navbar :hotel="hotel" :settings="settings" :ombrelli="ombrelli" :addpool="addpool" :addombrid="addombrid" :addombrell="addombrell" :editpool="editpool" :edit="edit"></navbar>

    <!-- <div class="h100 w20"></div> -->
  <div style="display: grid; justify-content: center; overflow-y: auto; height: 100vh; padding: 96px 0;">  

  <!-- {{ombrellos}}
  {{ombrelli}} -->
  <!-- <div id="embedded-slack" /> -->
  
    <div v-cloak class="" style="" v-if="!loading">
    <!-- <h1>{{hotel.hotelname}} - {{hotelid}}</h1> -->

    <!-- {{hotel.poolsettings}} -->
    <!-- {{ombrellos}} -->

    <VueDragResize :snapToGrid="true" :gridX="200" :gridY="200" class="pool grid" style="align-content: center; justify-content: center;" v-for="(pool, index) in hotel.pools" :key="pool._id" :isActive="edit" :x="pool.x" :y="pool.y" :w="pool.width" :h="pool.height" :z="997" v-on:resizing="(left, top, width, height) => pooldrag(index, left, top, width, height)" :isDraggable="edit" @dragstop="(left, top, width, height) => pooldrag(index, left, top, width, height)" :isResizable="edit">
    <a v-on:click="removePool(index)" style="z-index: 999;" class="btn" v-if="edit">remove</a>
    <span class="fas fa-swimming-pool" v-if="!edit" v-bind:style="{ fontSize: pool.width / 8 + 'px' }"></span>
<!--       <h1>Pool</h1>
      <p>{{pool.x}}</p>
      <p>{{pool.y}}</p>
      <p>{{pool.width}}</p>
      <p>{{pool.height}}</p> -->
    </VueDragResize>

        <VueDragResize :snapToGrid="true" :gridX="20" :gridY="20" class="blocco ombrello" v-for="(ombrello, index) in ombrelli" :key="ombrello._id" :isActive="edit" :x="ombrello.x" :y="ombrello.y" :w="ombrello.width" :h="ombrello.height" :z="997" v-on:resizing="resize" :isDraggable="edit" @dragstop="(left, top, width, height) => onResizing(index, left, top, width, height)" :isResizable="false">
          <div class="blocco seat" v-if="!ombrello.free && ombrello.location === 'pool'">
        <div class="header blocco row" v-if="hotel.poolsettings.beds || hotel.poolsettings.chairs">
          <div class="blocco" v-if="hotel.poolsettings.chairs">
            <img src="../assets/img/beach-deckchair-.png">
            <span><a v-on:click="removechair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.chairs}}<a v-on:click="addchair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>
          </div>
          <div class="blocco" v-if="hotel.poolsettings.beds">
            <img src="../assets/img/beach-chair.png">
            <span><a v-on:click="removebed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.beds}}<a v-on:click="addbed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>
          </div>
        </div>
        <div class="ident blocco row">
          <span v-if="hotel.poolsettings.room" class="room">{{ombrello.room}}</span>
          <span v-if="ombrello.guest" v-on:click="show(ombrello)">{{ombrello.guest}}</span>
          <span v-if="!ombrello.guest" v-on:click="show(ombrello)">no guest</span>
        </div>
        <div class="caldata blocco row" v-if="hotel.poolsettings.arrival || hotel.poolsettings.departure || hotel.poolsettings.ombrid">
          <div class="blocco nr" v-if="hotel.poolsettings.ombrid">{{ombrello.ombrid}}</div>
          <div class="blocco" v-if="hotel.poolsettings.arrival || hotel.poolsettings.departure">
            <span v-if="hotel.poolsettings.arrival"><span class="fa fa-chevron-right"></span> {{ombrello.arrival}}</span>
            <span v-if="hotel.poolsettings.departure"><span class="fa fa-chevron-left"></span> {{ombrello.departure}}</span>
          </div>
        </div>
        </div>

        <div class="blocco seat free drop" :id="ombrello._id" v-if="ombrello.free && ombrello.location === 'pool'">
            <div class="blocco nr" v-on:click="show(ombrello)" :id="ombrello._id">{{ombrello.ombrid}}</div>
            <!-- <span>{{ombrello._id}}</span> -->
          </div>

        </VueDragResize>

    </div>

    </div>

    <modal name="hello-world" width="50%" height="50%" :adaptive="true">
      <!-- {{ombrellos}} -->
      <!-- {{hotel}} -->
      <div class="grid edit w100">
        <div class="grid data h50">
          <!-- {{ombrellos}} -->
          <h1 v-on:click="changeombrid" v-if="!editombrid">{{ombrellos.ombrid}}</h1>
          <input type="text" v-if="editombrid" class="form-control" name="ombrid" v-model="ombrellos.ombrid">
          <p><strong>Guest Name</strong></p>
          <input type="text" class="form-control" name="guest" v-model="ombrellos.guest" >
          <input type="text" class="form-control" name="room" v-model="ombrellos.room"  placeholder="Room Number">
          <p><strong>Arrival and Departure</strong></p>
          <!-- <datepicker v-model="date" :range="true"></datepicker> -->
          <DateRange class="calendar" :sync-range.sync="range" :first-day-of-week="1" :lang="lang" @change="onChange"></DateRange>
          <div class=" spacer md"></div>
          <p><a v-on:click="updateombrello" class="btn btn-green">Update Umbrella</a></p>
          <div class=" spacer md"></div>
          <p><a v-on:click="closeombrello" class="btn btn-red" v-if="!ombrellos.free">close ombrello</a></p>
        </div>
        <div class="grid seats h50" :class="{ free : ombrellos.free }">
          <div class="grid">     
            <img src="../assets/img/beach-deckchair-@2x.png">
            <span><a v-on:click="ombrellos.chairs -= 1"><span class="fa fa-minus-square"></span></a>{{ombrellos.chairs}}<a v-on:click="ombrellos.chairs += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>
          <div class="grid">
            <img src="../assets/img/beach-chair@2x.png">
            <span><a v-on:click="ombrellos.beds -= 1"><span class="fa fa-minus-square"></span></a>{{ombrellos.beds}}<a v-on:click="ombrellos.beds += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>          
        </div>
      </div>

    </modal>

    

    <modal name="settings" width="50%" height="50%" :adaptive="true">
      <!-- {{hotel}} -->
      <div class="grid edit w100">
        <div class="grid data h50">
          <!-- {{ombrellos}} -->
          <h1>{{hotel.hotelname}}</h1>
          <label>cols</label>
          <input type="text" class="form-control" name="cols" v-model="hotel.cols" >
          <label>rows</label>
          <input type="text" class="form-control" name="rows" v-model="hotel.rows" >
          <label>lang</label>
          <input type="text" class="form-control" name="lang" v-model="hotel.lang" >
          <div class=" spacer md"></div>
          <p><a v-on:click="updatehotel" class="btn btn-green">Update Settings</a></p>
          <div class=" spacer md"></div>
        </div>
        <div class="grid seats h50">
          <div class="grid">     
            <img src="../assets/img/beach-deckchair-@2x.png">
            <span><a v-on:click="hotel.chairs -= 1"><span class="fa fa-minus-square"></span></a>{{hotel.chairs}}<a v-on:click="hotel.chairs += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>
          <div class="grid">
            <img src="../assets/img/beach-chair@2x.png">
            <span><a v-on:click="hotel.beds -= 1"><span class="fa fa-minus-square"></span></a>{{hotel.beds}}<a v-on:click="hotel.beds += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>          
        </div>
      </div>
    </modal>

<!--     <v-dialog>
    {{ombrellos}}
    <h1>{{foo}}</h1>
    </v-dialog> -->
<!--     <h4 v-if='!authenticated'>
      You are not logged in! Please <a @click='auth.login()'>Log In</a> to continue.
      <button class='btn btn-primary' v-on:click='gethotel()'>Get a hotel</button>
      <h1>Ombrelli</h1>
      </h4>      
    </h4> -->
  
</div>
</template>

<script>
  import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import datepicker from 'vue-date'
  import {DateRange} from 'vue-date-range'
  import moment from 'moment'
  import Navbar from '@/components/Navbar'
  import { Drag, Drop } from 'vue-drag-drop'
  import VueDragResize from 'vue-drag-resize'
  // import EmbeddedSlack from 'embedded-slack'
  // const chat = new EmbeddedSlack({
  //   containerId: 'embedded-slack',
  //   channel: 'C03M1FH6Y',
  //   token: 'xoxp-3715527188-3715527214-346873012933-85307408b261ae33e2a178e9a2c4914c'
  // })
  var host = process.env.ROOT_API
  // var host = 'http://drop3.drophost.it:44534'
  export default {
    name: 'pool',
    props: ['auth', 'authenticated'],
    data () {
      return {
        loading: true,
        hotel: '',
        secret: '',
        ombrelli: '',
        style: '',
        hotelid: '',
        ombrellos: '',
        addombrello: {
          ombrid: ''
        },
        date: ['2016-10-16', '2018-10-05'],
        lang: 'it',
        range: {
          startDate: moment(),
          endDate: moment().add(7, 'days')
        },
        firstDayOfWeek: 1,
        editombrid: false,
        dragging: null,
        lock: null,
        draggable: true,
        location: 'pool',
        edit: false
      }
    },
    components: {
      datepicker,
      Circle4,
      DateRange,
      'Navbar': Navbar,
      Drag,
      Drop,
      VueDragResize
      // EmbeddedSlack
      // chat
    },
    sockets: {
      connect: function () {
        console.log('socket connected')
      },
      stream: function (val) {
        console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          console.log('an umbrella was updated')
          this.getOmbrelli()
        }
      },
      disconnect: function () {
        console.log('socket error')
        this.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 5000
        })
      }
    },
    methods: {
      editpool () {
        // console.log(this.edit)
        if (this.edit) {
          this.edit = false
          this.updategrid()
        } else { this.edit = true }
      },
      removePool (index) {
        console.log(index)
        this.hotel.pools.splice(index, 1)
      },
      addpool () {
        // this.hotel.pools = []
        this.hotel.pools.push({
          x: 500,
          y: 500,
          height: 500,
          width: 400
        })
      },
      addombrid () {
        // this.hotel.pools = []
        this.ombrelli.push({
          free: true,
          location: 'pool',
          ombrid: 'pool',
          hotelid: this.hotel._id,
          user: this.hotel.user,
          width: 120,
          height: 120,
          x: 500,
          y: 500
        })
        this.ombrellos = {
          free: true,
          location: 'pool',
          ombrid: 'pool',
          hotelid: this.hotel._id,
          user: this.hotel.user,
          width: 120,
          height: 120,
          x: 500,
          y: 500 }
        // this.updateombrello()
      },
      onResizing (id, left, top, width, height) {
        // console.log(id, left, top, width, height)
        this.ombrelli[id].left = left.left
        this.ombrelli[id].top = left.top
        this.ombrelli[id].x = left.left
        this.ombrelli[id].y = left.top
        // this.ombrelli[id].x = left.left
        // this.ombrelli[id].left = left.left
      },
      resize (newRect) {
        console.log(newRect)
        this.width = newRect.width
        this.height = newRect.height
        this.top = newRect.top
        this.left = newRect.left
      },
      pooldrag (id, left, top, width, height) {
        // console.log(id, left, top, width, height)
        this.hotel.pools[id].x = left.left
        this.hotel.pools[id].y = left.top
        this.hotel.pools[id].width = left.width
        this.hotel.pools[id].height = left.height
      },
      handleDragover (group, data, event) {
        // console.log(data)
        // console.log(group.ombrid)
        // console.log(event)
        if (!group.free) {
          event.dataTransfer.dropEffect = 'none'
        }
      },
      handleDrop (group, data, key) {
        console.log(group.ombrello.ombrid, data.target.id)
        this.moveombrello(group.ombrello, data.target.id)
        // alert(`You dropped with data: ${JSON.stringify(data)}`)
      },
      changeombrid () {
        console.log('changeombrid')
        this.editombrid = true
      },
      onChange (range) {
        this.range = range
        console.log(moment(range.endDate._d))
      },
      setRange (p) {
        if (typeof p === 'number') {
          console.log(p)
          this.range = {
            startDate: moment().add(p, 'days'),
            endDate: moment()
          }
        }
      },
      show (ombrello) {
        console.log(ombrello)
        this.ombrellos = ombrello
        if (ombrello.free) {
          this.ombrellos.chairs = this.hotel.chairs
          this.ombrellos.beds = this.hotel.beds
        }
        // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
        this.date[0] = ombrello.arrival
        this.date[1] = ombrello.departure
        console.log(moment(ombrello.arrival, 'DD.MM.YYYY'))
        if (ombrello.arrival) { this.range.startDate = moment(ombrello.arrival, 'DD.MM.YYYY') }
        if (ombrello.departure) { this.range.endDate = moment(ombrello.departure, 'DD.MM.YYYY') }
        this.$modal.show('hello-world')
      },
      hide () {
        this.$modal.hide('hello-world')
      },
      settings () {
        this.$modal.show('settings')
      },
      updategrid: function () {
        console.log(this.ombrelli)
        // console.log(this.range['endDate'])
        // this.editombrid = false
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/api/updategrid', { ombrelli: this.ombrelli, hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            // this.$modal.hide('hello-world')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      updatehotel: function () {
        this.$http
          .post(host + '/api/updatehotel', { hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.$modal.hide('settings')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      updateombrello: function () {
        console.log(this.ombrellos)
        console.log(this.range['endDate'])
        this.ombrellos.free = false
        this.ombrellos.arrival = moment(this.range.startDate._d).format('DD.MM.YYYY')
        this.ombrellos.departure = moment(this.range.endDate._d).format('DD.MM.YYYY')
        this.editombrid = false
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      moveombrello: function (old, newo) {
        console.log(old, newo)
        // this.ombrellos = old
        // this.closeombrello()
        // old._id = newo
        // old.ombrid = ombrid
        // console.log(this.ombrellos)
        // this.ombrellos = newo
        this.$http
          .post(host + '/api/moveombrello', { old: old, newo: newo },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.dragging = null
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      closeombrello: function () {
        console.log(this.ombrellos)
        console.log(this.date)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/ombrelloni/close', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      addombrell: function () {
        console.log(this.addombrello, this.hotelid)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/ombrelloni/add', { ombrid: 'pool', hotelid: this.hotelid, location: this.location },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      editguest: function (index) {
        console.log(index.ombrid, index.edit)
        index.edit = true
        // Vue.set(this.ombrelli[index], 'edit', true)
      },
      saveEdit: function (index, guest) {
        // save your changes
        // this.toggleEdit(index, guest)
        console.log(index, guest)
        Vue.set(this.ombrelli[index], 'guest', guest)
      },
      getOmbrelli () {
        // console.log(localStorage.access_token)
        // this.$i18n.locale = 'en'
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized/richards',
          // .get('http://localhost:8000/authorized/' + this.$route.params.hotel,
          // .post(host + '/ombrelloni', { userid: localStorage.userid },
          .post(host + '/ombrelloni/pool', { hotelid: this.$route.params.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data.body)
            this.hotelid = data.body.hotels._id
            this.hotel = data.body.hotels
            if (data.body.hotels.chairs === undefined) {
              this.hotel.chairs = 1
            }
            if (data.body.hotels.beds === undefined) {
              this.hotel.beds = 1
            }
            this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', 284px);'
            // console.log('hotel: ' + this.hotelid)
            // console.log(data)
            this.ombrelli = data.body.ombrells
            this.loading = false
            this.$notify({
              group: 'foo',
              title: 'Hoteldata loaded',
              text: 'You are good to go',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
            this.$router.replace('/')
          })
      },
      addchair (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
            this.$notify({
              group: 'foo',
              title: 'Chair added',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
          })
      },
      removechair (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      addbed (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      removebed (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      changeguest (index, chair, guest) {
        console.log(this.ombrelli)
        console.log(index, chair, guest)
        // var newchairs = nr - 1
        // this.$http
        //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + localStorage.jwt
        //     }
        //   },
        //   ).then((data) => {
        //     console.log(data)
        //     // this.loading = false
        //     Vue.set(this.ombrelli[index], 'beds', newchairs)
        //   }, (error) => {
        //     console.log(error)
        //   })
      }
    },
    beforeMount () {
      this.getOmbrelli()
    },
    computed: {
      hotelgrid: function () {
      // `this` points to the vm instance
        return this.hotel.cols * this.hotel.rows
      },
      userLastCount () {
        console.log(this.ombrells)
      }
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Pool.vue?7f7f95ca